// Mock data for demo labs/clients

const labs = [
  {
    id: 'lab-001',
    name: 'Innovate Bio',
    industry: 'Biotech',
    size: 20,
    summary: 'A mid-sized biotech firm specializing in oncology research.',
    location: 'Boston, MA',
    contact: {
      name: 'Dr. Lisa Chen',
      email: 'lisa.chen@innovatebio.com',
      phone: '555-123-4567'
    },
    projects: ['gig-001']
  },
  {
    id: 'lab-002',
    name: 'VaxGen Labs',
    industry: 'Pharma',
    size: 50,
    summary: 'A pharmaceutical company focused on vaccine innovation.',
    location: 'Remote',
    contact: {
      name: 'Dr. Mark Evans',
      email: 'mark.evans@vaxgenlabs.com',
      phone: '555-234-5678'
    },
    projects: ['gig-002']
  },
  {
    id: 'lab-003',
    name: 'PharmaNext',
    industry: 'Pharma',
    size: 35,
    summary: 'A growing pharma company with a focus on analytical chemistry.',
    location: 'San Diego, CA',
    contact: {
      name: 'Dr. Priya Singh',
      email: 'priya.singh@pharmanext.com',
      phone: '555-345-6789'
    },
    projects: ['gig-003']
  }
];

export default labs;
